/****
 * 打印的方法
 */
import LodopPrint from './lodop/lodop'
import urlUitls from '../urlUitls'
import templateUtil from '../templateUtil'
import BrowserPrint from '../../libs/BrowserPrint-3.0.216.min'
import objectUtil from '../objectUtil'
import SatoUtils from './satoUtils'
import { toBase64 } from './base64Util'

const getValue = objectUtil.getValueByPath
import ajax from './ajax'
export default class PrintUtils {
  constructor(templateData, data, pgMessage, axios, GLOBAL, Message, props) {
    //模板编译数据
    this.templateData = templateData
    //模板编译数据中的data属性，，如果data是数组表示是批量打印，，则需要循环编译
    this.data = data
    this.pgMessage = pgMessage
    this.axios = axios
    this.GLOBAL = GLOBAL
    this.props = props
    this.Message = Message
  }
  run(code, ...arg) {
    if (['zebra', 'postek', 'lodop', 'sato', 'browser'].indexOf(code) === -1) {
      this.fineReport(...arg)
    } else {
      return this[code](...arg)
    }
  }
  //斑马打印
  async zebra(url) {
    const param = await this.rfidPrint(url)
    if (!param || !param.data) return
    let dataArray = param.data
      .map((im) => {
        return `${im.id}:${im.goodsDetail?.name}:${im.epc}`
      })
      .join('\n')
    console.error(`rfid 数据 顺序：\n ${dataArray}`)

    // for (let row of param.data) {
    //   // 获取数据集接口 取得数据
    //   const compileData = await this.getDataset(param.dataset, row)
    //   let lTemplate = templateUtil.compileData(param.content, compileData)
    //   lTemplate = JSON.stringify(lTemplate)
    //   BrowserPrint.getDefaultDevice(
    //     'printer',
    //     (device) => {
    //       device.send(lTemplate, undefined, (error) => this.Message.error(error))
    //       let ids = getValue(row, this.props.ifTimeKey, '')
    //       this.savePrint(ids)
    //     },
    //     (error) => {
    //       this.Message.error(error)
    //     }
    //   )
    // 获取数据集接口 取得数据
    // 斑马打印 保证打印顺序与表格显示顺序一致，不受接口影响，弊端，可能打印会出现缓慢的情况，因为需要等待接口
    let start = 0
    function orderGetTemplate(start, parent) {
      if (start >= param.data.length) return false
      parent.getDataset(param.dataset, param.data[start]).then(
        (res) => {
          const compileData = res
          let lTemplate = templateUtil.compileData(param.content, compileData)
          lTemplate = JSON.stringify(lTemplate)
          console.log(lTemplate)
          BrowserPrint.getDefaultDevice(
            'printer',
            (device) => {
              console.error(
                `rfid打印数据顺序正常：：\n ${param.data[start].id}:${param.data[start].goodsDetail?.name}:${param.data[start].epc}`
              )
              device.send(
                lTemplate,
                () => {
                  let ids = getValue(param.data[start], parent.props.ifTimeKey, '')
                  parent.savePrint(ids)
                  orderGetTemplate(++start, parent)
                },
                (error) => parent.Message.error(error)
              )
            },
            (error) => {
              console.error(
                `rfid error 数据顺序报错：\n ${param.data[start].id}:${param.data[start].goodsDetail?.name}:${param.data[start].epc}`
              )
              parent.Message.error(error)
              orderGetTemplate(++start, parent)
            }
          )
        },
        (error) => {
          console.error(error)
        }
      )
    }
    orderGetTemplate(start, this)
  }
  //博士得
  async postek(url, skipParamter) {
    //打印机状态是否就绪
    const status = await this.getRfidMachineStatus()
    if (status !== '0') return
    const param = await this.rfidPrint(url)

    if (!param || !param.data) return
    for (let row of param.data) {
      // 模板数据 获取 表达式数据
      let template = eval(param.content)
      // 获取数据集接口 取得数据
      let compileData = await this.getDataset(param.dataset, row)
      compileData = Object.assign(compileData, skipParamter)
      let lTemplate = templateUtil.compileData(template, compileData)
      console.log('lTemplate: ', lTemplate)

      lTemplate = JSON.stringify(lTemplate)
      const paramater = {
        reqParam: '1',
        printparams: lTemplate,
      }

      // ----------------- #35698，博士得增加批量打印 ----------------------
      const run = (row) => {
        let ids = getValue(row, this.props.ifTimeKey, '')
        this.savePrint(ids)
        this.Message.success('打印命令发送成功，打印中...')
      }
      // 打印队列
      const printQueue = []
      // 获取打印次数
      const printNum = row.sheets
      if (printNum > 1) {
        for (let n = 0; n < printNum; n++) {
          printQueue.push(ajax({ url: this.props.rfidUrl, type: 'POST', data: paramater }))
        }

        if (printQueue.length > 0) {
          // 批量打印
          const printRes = await Promise.all(printQueue).catch((err) => {
            if (err?.msg) this.Message.error(err.msg)
          })
          if (!printRes) continue
          let printRetval
          let printError = {}

          for (const item of printRes) {
            if (item?.retval == '0') {
              printRetval = item.retval
            } else {
              printError = item
            }
          }

          const retvalArr = printRetval ? [printRetval] : []

          if (retvalArr.length === 1) {
            run(row)
          } else {
            if (printError?.msg) this.Message.error(`打印发送失败:${printError.msg}`)
          }
        }

        continue
      }
      // ----------------- #35698，博士得增加批量打印 End ----------------------

      const res = await ajax({ url: this.props.rfidUrl, type: 'POST', data: paramater }).catch(
        (err) => {
          if (err?.msg) this.Message.error(err.msg || '打印发送失败:单次打印报错')
        }
      )
      if (res?.retval == '0') {
        run(row)
      } else {
        if (res?.msg) this.Message.error(`打印发送失败:${res.msg}`)
      }
    }
  }
  //佐藤
  async sato(url) {
    const socket = new SatoUtils('ws://localhost:8055/SATOPrinterAPI')
    await socket.open()
    let printers = await socket.send({ Method: 'Driver.GetDriverList' })
    printers = printers !== 'null' ? JSON.parse(printers) : []
    if (!printers || printers.length === 0) {
      this.Message.error('未识别到打印佐藤打印机')
      socket.close()
      return
    }
    //默认取第一个打印机
    const printer = printers[0]
    const param = await this.rfidPrint(url)
    if (!param || !param.data) return
    for (let row of param.data) {
      // 获取数据集接口 取得数据
      const compileData = await this.getDataset(param.dataset, row)
      let lTemplate = templateUtil.compileData(param.content, compileData)
      const base64Str = toBase64(lTemplate)
      const parintParam = {
        Method: 'Driver.SendRawData',
        Parameters: {
          DriverName: printer.DriverName,
          Data: base64Str,
        },
      }
      let res = await socket.send(parintParam)
      res = JSON.parse(res)
      if (!res || res.Result !== 'Executed') {
        this.Message.error('打印失败')
        return
      }

      let ids = getValue(row, this.props.ifTimeKey, '')
      this.savePrint(ids)
    }
    socket.close()
  }
  async rfidPrint(url) {
    return new Promise((resolve, reject) => {
      // 获取模板 详情内容
      let param = urlUitls.getRequestParamter(url)
      const tParam = { viewlet: param.viewlet }
      this.axios.get('/rest/ezcomp/report/templateDetail', { params: tParam }).then((res) => {
        if (res.data.code === 200) {
          let template = res.data.data
          let data = this.data
          if (data && !Array.isArray(data)) {
            //批量的情况
            data = [data]
          }
          // 编译 当前 模板分类 - 访问地址 对应的剩余参数 目前支持一级 只编译一级
          Object.keys(param).forEach((im) => {
            param[im] = templateUtil.compileData(param[im], { data: data[0] })
          })
          if (!data) {
            reject('无数据')
          } else {
            resolve({ data, content: template.content, dataset: template.dataset, ...param })
          }
        }
      })
    })
  }
  //获取模版数据源
  async getDataset(dataset, row) {
    return new Promise((resolve, reject) => {
      const keys = Object.keys(dataset)
      const values = keys.map((key) => {
        const url = templateUtil.compileData(dataset[key], row)
        return this.axios.get(url)
      })
      Promise.all(values)
        .then((res) => {
          let data = {}
          res.map((item, index) => {
            data[keys[index]] = item.data.data
          })
          resolve(data)
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  }
  // lodop
  async lodop(url, skipParamter, printer, browser) {
    const lodopPrint = this.lodopPrint ?? new LodopPrint(this.axios)
    let urlParam = lodopPrint.setParam(url, this.templateData, this.data, skipParamter)
    lodopPrint.run(urlParam, printer, browser, this.Message) // 需求6543 ：增加 无打印数据时的提示 参数message
    let ids = ''
    if (Array.isArray(this.data)) {
      ids = this.data.map((im) => getValue(im, this.props.ifTimeKey, '')).join(',')
    } else {
      ids = this.props.ifTimeValue
        ? this.props.ifTimeValue
        : getValue(this.data, this.props.ifTimeKey, '')
    }
    // xq6468:列表批量打印，多次掉接口
    if (Array.isArray(this.data)) {
      const saveArr = []
      for (let i = 0; i < this.data.length; i++) {
        saveArr.push(this.savePrint(this.data[i].id))
      }
      return Promise.all(saveArr)
    } else {
      return this.savePrint(ids)
    }
  }
  //浏览器打印
  browser(url, skipParamter) {
    this.lodop(url, skipParamter, {}, true)
  }
  //帆软
  fineReport(url, skipParamter) {
    if (this.data && !Array.isArray(this.data)) {
      let tempUrl = url
      this.templateData.data = this.data
      tempUrl = templateUtil.compileData(tempUrl, this.templateData)
      var win1 = window.open(tempUrl)
      this.savePrint(
        this.props.ifTimeValue
          ? this.props.ifTimeValue
          : getValue(this.data, this.props.ifTimeKey, '')
      )
      if (!win1 || !win1.location) {
        this.Message.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
      }
    } else {
      let conf = this.fineReportParam(url, this.templateData, this.data, skipParamter)
      if (!conf) return
      conf.config.data.reportlets = JSON.stringify(conf.config.data.reportlets)
      //加载css
      // var head = document.getElementsByTagName('head')[0];
      // var link = document.createElement('link');
      // var tempCss = conf.batchPrintCss;
      // if (tempCss.indexOf('http://') == -1 && tempCss.indexOf('https://') == -1 && conf.findBiUrl) {
      //     tempCss = conf.findBiUrl + tempCss;
      // }
      // link.href = tempCss;
      // link.rel = 'stylesheet';
      // link.type = 'text/css';
      // head.appendChild(link);
      //加载js并调用打印
      if (window.FR) {
        conf.config.data.reportlets = window.FR.cjkEncode(conf.config.data.reportlets)
        window.FR.doURLPrint(conf.config)
      } else {
        var script = document.createElement('script')
        script.type = 'text/javascript'
        var temp = conf.batchPrintJs
        if (temp.indexOf('http://') == -1 && temp.indexOf('https://') == -1 && conf.findBiUrl) {
          temp = conf.findBiUrl + temp
        }
        script.src = temp
        script.onload = function () {
          conf.config.data.reportlets = window.FR.cjkEncode(conf.config.data.reportlets)
          window.FR.doURLPrint(conf.config)
        }
        document.getElementsByTagName('head')[0].appendChild(script)
      }
      this.savePrint(this.data.map((im) => getValue(im, this.props.ifTimeKey, '')).join(','))
    }
  }
  //组装帆软打印的参数
  fineReportParam(url, templateData, data, skipParamter) {
    let paramAarr = []
    for (let item of data) {
      let tempUrl = url
      templateData.data = item
      tempUrl = templateUtil.compileData(tempUrl, templateData)
      let paramItem = urlUitls.getRequestParamter(tempUrl)
      paramItem = Object.assign(paramItem, skipParamter)
      paramItem.reportlet = paramItem.viewlet
      delete paramItem.viewlet
      paramAarr.push(paramItem)
    }
    let printUrl = url
    if (printUrl.indexOf('?') != -1) {
      printUrl = printUrl.split('?')[0]
    }
    let temp = {
      printUrl,
      data: {
        reportlets: paramAarr,
      },
    }
    let config = Object.assign({ pageType: 0 }, this.props.batchPrintConf, temp)
    config = {
      config,
      // batchPrintCss: this.batchPrintCss,
      batchPrintJs: this.props.batchPrintJs,
      findBiUrl: this.GLOBAL.findBiUrl,
    }
    return config
  }
  // 获取博士得rfid打印机状态
  getRfidMachineStatus() {
    return new Promise((resolve) => {
      let printparams = [
        { PTK_OpenUSBPort: 255 },
        { PTK_ErrorReport_USBInterrupt: 'statusCode:' },
        { PTK_CloseUSBPort: '' },
      ]
      printparams = JSON.stringify(printparams)
      const param = {
        reqParam: '1',
        printparams: printparams,
      }
      ajax({ url: this.props.rfidUrl, type: 'POST', data: param })
        .then((res) => {
          if (res.retval === '0') {
            // Message.success(`RFID打印机状态：${this.transRfidStatusName(res.retval)}`)
            resolve(res.retval)
          } else {
            this.Message.error(`RFID打印机错误码:${res.retval}；错误信息：${res.msg}`)
            resolve(null)
          }
        })
        .catch((err) => {
          this.Message.error(err.msg)
          resolve(null)
        })
    })
  }
  // 转换博士得RFID打印机 状态码 与 状态名的转换
  transRfidStatusName(statusCode) {
    let status = ''
    switch (statusCode) {
      case '0':
        status = '就绪'
        break
      case '1':
        status = '语法错误'
        break
      case '4':
        status = '正在打印机中'
        break
      case '82':
        status = '碳带探测出错'
        break
      case '83':
        status = '标签探测出错'
        break
      case '86':
        status = '切刀探测出错'
        break
      case '87':
        status = '打印头未关闭'
        break
      case '88':
        status = '暂停打印'
        break
      case '109':
        status = 'RFID写入数据失败'
        break
      case '110':
        status = 'RFID写入数据失败，打印机将重试写入直到达到最大重试次数'
        break
      case '111':
        status = 'RFID标签校准失败'
        break

      case '116':
        status = '读取RFID标签数据失败'
        break
      default:
        status = '未知打印机状态'
    }
    return status
  }
  //保存打印次数
  savePrint(ids) {
    if (!this.props.savePrintCount) return
    //xq6343,保存打印次数，所需传递的参数
    let params = { ids: ids }
    if (this.props.savePrintCountParams) {
      params = Object.assign({}, { id: ids }, this.props.savePrintCountParams)
    }

    return (
      this.axios
        // .post(this.props.savePrintCount, { ids: ids })
        .post(this.props.savePrintCount, params)
    )
    // .then(() => {})
    // .catch((error) => {
    //   console.error(error)
    // })
  }
  //获取打印机
  getPrinter(template) {
    if (template?.server?.code === 'lodop') {
      return this.getLodopPrinter()
    }
  }
  //获取lodop打印机
  async getLodopPrinter() {
    const lodopPrint = this.lodopPrint ?? new LodopPrint(this.axios)
    return await lodopPrint.getPrinter()
  }
}
